// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__23ZKe","list":"PatternAutocomplete_list__3DsTR"};